import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { contractConstants, contractModels } from '..';

export const useOnlineContractConfig = () =>
  useQuery<contractModels.IOnlineContractConfig[]>({
    queryKey: [contractConstants.queryKeys.ONLINE_CONTRACT_CONFIG],
    queryFn: async () => {
      const res = await $api.get('/v1/online-contract/config');

      return res?.data?.data;
    }
  });
